import { FC } from 'react';
import { ChipTone, ListCheckChip as ListCheckChipModel } from '../../helpers/listCheckHelpers';
import { ListCheckChipSpan } from '../../styles';

const ICON_PATHS: Record<ChipTone, string> = {
  good: 'm5.2 8.2 1.9 1.9 3.7-4.2',
  bad: 'm5.8 5.8 4.4 4.4M10.2 5.8l-4.4 4.4',
  open: 'M8 4.7v3.7M8 11.1v.2',
  neutral: 'M5.4 8h5.2'
};

interface ListCheckChipProps {
  chip: ListCheckChipModel;
}

const ListCheckChip: FC<ListCheckChipProps> = ({ chip }) => (
  <ListCheckChipSpan $tone={chip.tone} data-testid="list-check-chip" data-tone={chip.tone}>
    <svg
      width="13"
      height="13"
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.9"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <circle cx="8" cy="8" r="6.3" />
      <path d={ICON_PATHS[chip.tone]} />
    </svg>
    {chip.text}
  </ListCheckChipSpan>
);

export default ListCheckChip;
